<template>
  <div>
    <loading
      loader="dots"
      :height="170"
      :width="170"
      color="#3282b8"
      background-color="#505273"
      transition="fade"
      :active="isLoading"
      :is-full-page="true"
    ></loading>
    <div class="col-md-6">
      <base-input label="JKKP Form Type">
        <el-select
          class="select-primary"
          size="large"
          placeholder="Single Select"
          v-model="incidentid"
          @change="getJKKP()"
        >
          <el-option
            v-for="option in incidentType"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          >
          </el-option>
        </el-select>
      </base-input>
    </div>
    <modal :show.sync="modals.openmap" type="large">
      <h2
        slot="header"
        class="modal-title text-center"
        id="modal-title-default"
      >
        Drop pin to the incident location and close the popup when done.
        Latitude and longitude of the location will appear.
      </h2>
      <div class="row">
        <div id="map" class="map" style="height: 550px">
          <l-map
            ref="map"
            :zoom="zoom"
            :center="center"
            class="sidebar-map"
          >
          <!-- :bounds="bounds" -->
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-marker
              v-for="marker in markers"
              :lat-lng="marker.location"
              :key="marker.addMarker"
              :icon="icon"
              draggable
              @dragend="onDragEnd"
            >
              <!-- <l-tooltip :content="marker.pointName" /> -->
            </l-marker>
          </l-map>
        </div>
      </div>
      <div class="row">
        <div class="col-lg" style="text-align: center">
          <base-button type="success" @click="modals.openmap = false">
            Enter
          </base-button>
        </div>
      </div>
    </modal>
    <div v-if="jkkp === 6">
      <!-- JKKP 6 Form -->
      <h4 class="info-text">JKKP 6 Form</h4>
      <div class="row">
        <div class="col-lg-6">
          <h4 class="info-text">BAHAGIAN A - Maklumat Pemberitahu</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input label="Nama" v-model="notifier.name"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input

                    label="Jawatan"
                    v-model="notifier.designation"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input
                        label="Nama Organisasi"
                        v-model="notifier.org"
                      ></base-input>
                      <base-input
                        label="No Telefon"
                        v-model="notifier.phoneno"
                      ></base-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Organisasi">
                    <textarea class="address" v-model="notifier.add"></textarea>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="No. ROC"
                    v-model="notifier.roc"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="No. Pend. JKKP"
                    v-model="notifier.jkkpregno"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Kod Industri"
                    v-model="notifier.industrycode"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Sektor Industri"
                    v-model="notifier.industrysector"
                  ></base-input>
                </div>
                <div class="col-lg-12">
                  <base-input
                    label="Nama orang yang boleh dihubungi"
                    v-model="notifier.other"
                  >
                  </base-input>
                </div>
                <div class="col-lg-12">
                  <base-input
                    label="No Telefon Orang yang boleh dihubungi"
                    v-model="notifier.otherphoneno"
                  >
                  </base-input>
                </div>
                <div class="col-lg-12">
                  <base-input
                    label="Kod Klasifikasi"
                    v-model="notifier.classificationcode"
                  >
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-6"
          style="border-left: solid red; padding-bottom: 1%"
        >
          <h4 class="info-text">BAHAGIAN B - Orang Yang Terlibat</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input label="Nama" v-model="victim.name"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Tarikh Lahir">
                    <el-date-picker
                      v-model="victim.dob"
                      type="date"
                    ></el-date-picker>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="No K/P" v-model="victim.kp"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="No Pekerja"
                    v-model="victim.nopekerja"
                  ></base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    label="Warganegara"
                    v-model="victim.nationality"
                  ></base-input>
                </div>
                <div class="col-md-4">
                  <base-input label="Jantina" v-model="victim.gender">
                    <el-select
                      class="select-primary"
                      size="large"
                      placeholder="Jantina"
                      v-model="victim.gender"
                    >
                      <el-option
                        v-for="option in genderOption"
                        class="select-primary"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    label="Pekerjaan"
                    v-model="victim.occupation"
                  ></base-input>
                </div>
                <div class="col-md-12">
                  <base-input label="Tempat Kejadian" v-model="inLocation">
                  </base-input>
                </div>
                <div class="col-md-10">
                  <base-input label="Latitude" v-model="lat"> </base-input>
                </div>
                <div class="col-md-2" style="top: 20px">
                  <el-tooltip
                    content="Click to pin the location"
                    placement="top"
                  >
                    <base-button type="success" @click="modalShown()" class="btn-icon btn-simple">
                      <i
                        class="tim-icons icon-square-pin text-success"
                      ></i>
                      <!-- style="font-size: 30px" -->
                    </base-button>
                  </el-tooltip>
                </div>
                <div class="col-md-12">
                  <base-input label="Longitude" v-model="lng"> </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Nama Organisasi">
                    <textarea
                      class="address"
                      v-model="victim.orgname"
                    ></textarea>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Organisasi">
                    <textarea
                      class="address"
                      v-model="victim.orgaddr"
                    ></textarea>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Tarikh Kejadian">
                    <el-date-picker
                      v-model="victim.intimestamp"
                      type="date"
                    ></el-date-picker>
                  </base-input>

                  <base-input label="Masa Kejadian" >
                    <!-- selectableRange: '00:00:00 - 23:59:59' -->
                    <el-time-picker
                    @change="submit()"
                      v-model="inTime"
                      value-format="HH:mm:ss"
                      :picker-options="{
                        format: 'hh:mm:ss',
                      }"
                    ></el-time-picker>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Tarkih Mula Lapor kepada JKKP">
                    <el-date-picker
                      v-model="victim.reportdate"
                      type="date"
                    ></el-date-picker>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- JKKP 7 Form -->
      <h4 class="info-text">JKKP 7 Form</h4>
      <div class="row">
        <div class="col-lg-6">
          <h4 class="info-text">
            BAHAGIAN A1 - Pemberitahuan - Peraturan 7 (1)
          </h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input label="Nama" v-model="notifier.name"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Jawatan"
                    v-model="notifier.designation"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input
                        label="Nama Organisasi"
                        v-model="notifier.org"
                      ></base-input>
                      <base-input
                        label="No Telefon"
                        v-model="notifier.phoneno"
                      ></base-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Organisasi">
                    <textarea class="address" v-model="notifier.add"></textarea>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="No. ROC"
                    v-model="notifier.roc"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="JKKP"
                    v-model="notifier.jkkpregno"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Kod Industri"
                    v-model="notifier.industrycode"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Sektor Industri"
                    v-model="notifier.industrysector"
                  ></base-input>
                </div>
                <div class="col-lg-12">
                  <base-input
                    label="Nama orang yang boleh dihubungi"
                    v-model="notifier.other"
                  >
                  </base-input>
                </div>
                <div class="col-lg-12">
                  <base-input
                    label="No Telefon Orang yang boleh dihubungi"
                    v-model="notifier.otherphoneno"
                  >
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-6"
          style="border-left: solid red; padding-bottom: 1%"
        >
          <h4 class="info-text">
            BAHAGIAN A2 - Pemberitahuan - Peraturan 7 (2) Pengamal Perubatan
            Berdaftar
          </h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input label="Nama" v-model="medic.name"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Jawatan"
                    v-model="medic.designation"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="No Telefon"
                    v-model="medic.telno"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Nama Klinik / Hospital"
                    v-model="medic.clinicname"
                  >
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Klinik / Hospital">
                    <textarea class="address" v-model="medic.addr"></textarea>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-12"
          style="border-top: solid red; padding-bottom: 1%"
        >
          <h4 class="info-text">BAHAGIAN B - Orang Yang Terlibat</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input label="Nama" v-model="victim.name"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Tarikh Lahir">
                    <el-date-picker
                      v-model="victim.dob"
                      type="date"
                    ></el-date-picker>
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    label="No K/P atau No. Passport"
                    v-model="victim.kp"
                  ></base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    label="No Pekerja"
                    v-model="victim.nopekerja"
                  ></base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    label="Warganegara"
                    v-model="victim.nationality"
                  ></base-input>
                </div>
                <div class="col-md-4">
                  <base-input label="Jantina">
                    <el-select
                      class="select-primary"
                      size="large"
                      placeholder="Jantina"
                      v-model="victim.gender"
                    >
                      <el-option
                        v-for="option in genderOption"
                        class="select-primary"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    label="Pekerjaan"
                    v-model="victim.occupation"
                  ></base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    label="Nama Organisasi"
                    v-model="victim.org"
                  ></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Organisasi">
                    <textarea
                      style="height: 105px"
                      class="address"
                      v-model="victim.orgaddr"
                    ></textarea>
                  </base-input>
                </div>
                <div class="col-md-12">
                  <base-input label="Tempat Kejadian" v-model="inLocation">
                  </base-input>
                </div>
                <!-- <div class="row"> -->
                <div class="col-md-10">
                  <base-input label="Latitude" v-model="lat"> </base-input>
                </div>
                <div class="col-md-2" style="top: 9px">
                  <el-tooltip
                    content="Click to pin the location"
                    placement="top"
                  >
                    <base-button @click="modalShown()" class="btn-icon btn-simple" style="top: 10px">
                      <i
                        class="tim-icons icon-square-pin text-success"
                      ></i>
                      <!-- style="font-size: 30px" -->
                    </base-button>
                  </el-tooltip>
                </div>
                <div class="col-md-12">
                  <base-input label="Longitude" v-model="lng"> </base-input>
                </div>
                <!-- </div> -->
                <div class="col-md-6">
                  <base-input label="Tarikh Kejadian">
                    <el-date-picker
                      v-model="victim.intimestamp"
                      type="date"
                    ></el-date-picker>
                  </base-input>

                  <base-input label="Masa Kejadian">
                    <!-- selectableRange: '00:00:00 - 23:59:59' -->
                    <el-time-picker
                    @change="submit()"
                      v-model="inTime"
                      value-format="HH:mm:ss"
                      :picker-options="{
                        format: 'hh:mm:ss',
                      }"
                    ></el-time-picker>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Tarkih Mula Lapor kepada JKKP">
                    <el-date-picker
                      v-model="victim.reportdate"
                      type="date"
                    ></el-date-picker>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col text-center">
        <!-- <base-button @click="submit()">Finish</base-button>
        <div class="d-flex justify-content-center spinner" v-if="load">
          <circle-8></circle-8>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  TimePicker,
  TimeSelect,
  Tooltip,
} from "element-ui";
import moment, { utc } from "moment";
import swal from "sweetalert2";
import { Modal } from "src/components";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
  LTooltip,
} from "vue2-leaflet";
import { latLngBounds, latLng } from "leaflet";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["parentData"],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
    [Tooltip.name]: Tooltip,
    Modal,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    Loading,
    Circle8,
  },
  props: ["test1"],
  data() {
    return {
      genderOption: [
        {
          value: "Female",
          label: "Female",
        },
        {
          value: "Male",
          label: "Male",
        },
      ],
      load: false,
      isLoading: false,
      image: null,
      zoom: 10,
      icon: L.icon({
        iconUrl: require("@/assets/img/pinstart.png"),
        iconSize: [60, 65], // size of the icon
        iconAnchor: [60, 65], // point of the icon which will correspond to marker's location
        shadowAnchor: [60, 65], // the same for the shadow
        shadowSize: [60, 65],
        popupAnchor: [-3, -76],
      }),
      center: L.latLng(2.920715, 101.63724),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      markers: [
        {
          location: L.latLng(2.920715, 101.63724),
        },
      ],
    //   bounds: [[2.920715, 101.63724]],
      modals: {
        openmap: false,
      },
      incidentid: 1,
      incidentType: [],
      jkkp: 6,
      formtype: [
        {
          value: 6,
          label: "JKKP 6 Form",
        },
        {
          value: 7,
          label: "JKKP 7 Form",
        },
      ],
      value1: "",
      tableSiteRoute: [
        {
          siteRoute: "Route A",
        },
        {
          siteRoute: "Route B",
        },
      ],
      selects: {
        condition: [
          { value: "operational", label: "Operational" },
          { value: "Not operational", label: "Not Operational" },
        ],
      },
      model: {
        file: null,
      },
      idrecord: "",
      notifier: {
        name: "",
        designation: "",
        org: "",
        phoneno: "",
        add: "",
        roc: "938781-W",
        jkkpregno: "SL/18/23/118751",
        other: "",
        otherphoneno: "",
        industrycode: "74931",
        industrysector: "Industrial Waste Collection & Disposal Service",
        classificationcode: "90002"
      },
      victim: {
        name: "",
        dob: "",
        kp: "",
        org: "",
        nopekerja: "",
        nationality: "",
        gender: "",
        occupation: "",
        inlocation: "",
        intime: "",
        orgname: "",
        orgaddr: "",
        intimestamp: "",
        reportdate: "",
      },
      medic: {
        name: "",
        designation: "",
        telno: "",
        clinicname: "",
        addr: "",
      },
      doc: {
        diagnosis: "",
        diagnosis_date: "",
        name: "",
        addr: "",
      },
      indetails: "",
      inTime: "",
      inLocation: "",

      firstStepData: [],
      lat: "",
      lng: "",
      data: []
    };
  },
  created() {
    this.getIncidentType();
    this.victim.dob = moment().format("YYYY-MM-DD")
    this.victim.intimestamp = moment().format("YYYY-MM-DD")
    this.victim.reportdate = moment().format("YYYY-MM-DD")
    this.inTime = moment().format("HH:mm:ss")
  },
  mounted() {
    this.getImage();
  },
  methods: {
    modalShown() {
      this.modals.openmap = true
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    getImage() {
      this.$root.$on("image", (data) => {
        console.log(data);
        this.image = data;
      });
    },
    validate() {
      console.log("masuk");
      
      var decimal = Number(this.lat) === this.lat && this.lat % 1 !== 0;
      var long = Number(this.lng) === this.lng && this.lng % 1 !== 0;
      console.log(decimal);
      if (decimal == false) {
        swal({
          title: "Data Error!",
          text: "Latitude must be in decimal value",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      } else if (long == false) {
        swal({
          title: "Data Error!",
          text: "Longitude must be in decimal value",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      } else {
        if (this.jkkp == 6) {
          if (
            // check notifier and victim empty details
            this.notifier.name == "" ||
            this.notifier.designation == "" ||
            this.notifier.org == "" ||
            this.notifier.phoneno == "" ||
            this.notifier.add == "" ||
            this.notifier.roc == "" ||
            this.notifier.jkkpregno == "" ||
            this.notifier.industrycode == "" ||
            this.notifier.industrysector == "" ||
            this.victim.name == "" ||
            this.victim.dob == "" ||
            this.victim.kp == "" ||
            //   this.victim.intime == "" ||
            this.victim.nopekerja == "" ||
            this.victim.nationality == "" ||
            this.victim.gender == "" ||
            this.victim.occupation == "" ||
            this.lat == "" ||
            this.lng == "" ||
            this.victim.orgaddr == "" ||
            this.victim.orgname == "" ||
            this.victim.intimestamp == "" ||
            this.victim.reportdate == ""
          ) {
            swal({
              title: "Data Error!",
              text: "All data must be filled in.",
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          } else {
            //   this.$root.$emit("jkkp", this.jkkp);
            // this.load = true;
            // this.isLoading = true;
            let obj = {
              jkkp: this.jkkp,
              incidenttype: parseInt(this.incidentid),
              investigationid: 0,
              accidentclass: 1,
              accidenttype: 1,
              accidentcause: 1,
              notifiername: this.notifier.name,
              notifierdesignation: this.notifier.designation,
              notifiercompany: this.notifier.org,
              notifiercompanyaddr: this.notifier.add,
              notifiertelno: this.notifier.phoneno,
              rocno: this.notifier.roc,
              jkkpregno: this.notifier.jkkpregno,
              othercontact: this.notifier.other,
              industrycode: this.notifier.industrycode,
              industrysector: this.notifier.industrysector,
              medicname: "",
              medicdesignation: "",
              mediccompany: "",
              mediccompanyaddr: "",
              medictelno: "",
              diagnosis: "",
              diagnosisdate: "",
              doctorname: "",
              doctoraddr: "",
              victimname: this.victim.name,
              victimbirth: moment(this.victim.dob).format("YYYY-MM-DD"),
              victimkp: this.victim.kp,
              victimnation: this.victim.nationality,
              victimsex: this.victim.gender,
              victimoccup: this.victim.occupation,
              victimcompany: this.victim.orgname,
              victimcompanyaddr: this.victim.orgaddr,
              victimstaffid: this.victim.nopekerja,
              victimage: "",
              victimtelno: "",
              victimworkarea: this.victim.orgaddr,
              victimworkscope: "",
              victimsv: "",
              victimstarwork: "",
              victimhomeaddr: "",
              vehregno: "",
              vehtype: "",
              roadtax: "",
              puspakom: "",
              incidentloc: this.inLocation,
              incidentlocdetail: "",
              incidenttime:
                moment(this.victim.intimestamp).format("YYYY-MM-DD") +
                "T" +
                this.inTime,
              reportdatetoJKKP: moment(this.victim.reportdate).format(
                "YYYY-MM-DD"
              ),
              incidentimg: this.image,
              incidentlat: this.lat.toString(),
              incidentlong: this.lng.toString(),
              incidentdetail: "",
              noofmc: "",
              nooflti: "",
              classcode: this.notifier.classificationcode
            };
            this.data.push(obj)
            return this.$validator.validateAll().then((res) => {
                this.$root.$emit("secB", obj)
                return res;
            });
            //   data1.push(obj);

            // this.$http.post(":9994/api/v1/mobile/incident", obj).then((res) => {
            //   if (!res.error) {
            //     let response = res.message;
            //     swal({
            //       title: "Successfull!",
            //       text: res.message,
            //       type: "success",
            //       confirmButtonClass: "btn btn-success btn-fill",
            //       buttonsStyling: false,
            //     }).then((result) => {
            //       this.$router.go();
            //     });
            //     this.isLoading = false;
            //     this.load = false;
            //   } else {
            //     swal({
            //       title: "Something went wrong!",
            //       text: res.message,
            //       type: "warning",
            //       confirmButtonClass: "btn btn-success btn-fill",
            //       buttonsStyling: false,
            //     });
            //   }
            // });
          }
        } else if (this.jkkp == 7) {
          if (
            // check notifier and victim empty details
            this.notifier.name == "" ||
            this.notifier.designation == "" ||
            this.notifier.org == "" ||
            this.notifier.phoneno == "" ||
            this.notifier.add == "" ||
            this.notifier.roc == "" ||
            this.notifier.jkkpregno == "" ||
            this.notifier.industrycode == "" ||
            this.notifier.industrysector == "" ||
            this.medic.name == "" ||
            this.medic.designation == "" ||
            this.medic.telno == "" ||
            this.medic.clinicname == "" ||
            this.medic.addr == "" ||
            this.victim.name == "" ||
            this.victim.dob == "" ||
            this.victim.kp == "" ||
            this.victim.nopekerja == "" ||
            this.victim.nationality == "" ||
            this.victim.gender == "" ||
            this.victim.occupation == "" ||
            this.victim.org == "" ||
            this.lat == "" ||
            this.lng == "" ||
            this.victim.intimestamp == "" ||
            this.victim.reportdate == ""
          ) {
            swal({
              title: "Data Error!",
              text: "All data must be filled in.",
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          } else {
            // this.load = true;
            // this.isLoading = true;
            let obj = {
              jkkp: this.jkkp,
              incidenttype: this.incidentid,
              investigationid: 0,
              accidentclass: 1,
              accidenttype: 1,
              accidentcause: 1,
              notifiername: this.notifier.name,
              notifierdesignation: this.notifier.designation,
              notifiercompany: this.notifier.org,
              notifiercompanyaddr: this.notifier.add,
              notifiertelno: this.notifier.phoneno,
              rocno: this.notifier.roc,
              jkkpregno: this.notifier.jkkpregno,
              othercontact: this.notifier.other,
              industrycode: this.notifier.industrycode,
              industrysector: this.notifier.industrysector,
              medicname: this.medic.name,
              medicdesignation: this.medic.designation,
              mediccompany: this.medic.clinicname,
              mediccompanyaddr: this.medic.addr,
              medictelno: this.medic.telno,
              diagnosis: "",
              diagnosisdate: "",
              doctorname: "",
              doctoraddr: "",
              victimname: this.victim.name,
              victimbirth: moment(this.victim.dob).format("YYYY-MM-DD"),
              victimkp: this.victim.kp,
              victimnation: this.victim.nationality,
              victimsex: this.victim.gender,
              victimoccup: this.victim.occupation,
              victimcompany: this.victim.org,
              victimcompanyaddr: this.victim.orgaddr,
              victimstaffid: this.victim.nopekerja,
              victimage: "",
              victimtelno: "",
              victimworkarea: this.victim.orgaddr,
              victimworkscope: "",
              victimsv: "",
              victimstarwork: "",
              victimhomeaddr: "",
              vehregno: "",
              vehtype: "",
              roadtax: "",
              puspakom: "",
              incidentloc: this.inLocation,
              incidentlocdetail: "",
              incidenttime:
                moment(this.victim.intimestamp).format("YYYY-MM-DD") +
                "T" +
                this.inTime,
              reportdatetoJKKP: moment(this.victim.reportdate).format(
                "YYYY-MM-DD"
              ),
              incidentimg: this.image,
              incidentlat: this.lat.toString(),
              incidentlong: this.lng.toString(),
              incidentdetail: "",
              noofmc: "",
              nooflti: "",
            };
            this.data.push(obj)
            return this.$validator.validateAll().then((res) => {
                this.$root.$emit("secB", obj)
                return res;
            });
            
            // data1.push(obj);
            // this.$http.post(":9994/api/v1/mobile/incident", obj).then((res) => {
            //   if (!res.error) {
            //     let response = res.message;
            //     swal({
            //       title: "Successfull!",
            //       text: res.message,
            //       type: "success",
            //       confirmButtonClass: "btn btn-success btn-fill",
            //       buttonsStyling: false,
            //     }).then((result) => {
            //       this.$router.go();
            //     });
            //     this.isLoading = false;
            //     this.load = false;
            //   } else {
            //     swal({
            //       title: "Something went wrong!",
            //       text: res.message,
            //       type: "warning",
            //       confirmButtonClass: "btn btn-success btn-fill",
            //       buttonsStyling: false,
            //     });
            //   }
            // });
          }
        } else {
          swal({
            title: "Data Error!",
            text: "Invalid form",
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      }
      console.log(this.data)
      
    },
    onDragEnd(event) {
      //   console.log(event);
      this.lat = event.target._latlng.lat;
      this.lng = event.target._latlng.lng;
      console.log(this.lat, this.lng);
    },
    getIncidentType() {
      this.incidentType = [];
      this.$http.get(":9994/api/v1/setting/incidentType").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              jkkp: response[i].jkkp,
              label: response[i].incidentname,
              value: response[i].InTypeID,
            };
            this.incidentType.push(obj);
          }
        }
      });
      this.incidentid = 2
    },
    getForm() {},
    getJKKP() {
      console.log(this.incidentid);
      // get jkkpform id (6 or 7)
      for (var i = 0; i < this.incidentType.length; i++) {
        if (this.incidentid == this.incidentType[i].value) {
          this.jkkp = this.incidentType[i].jkkp;
        }
      }
    },
    // validate() {
    //     console.log("kkkk")
    //     this.submit();
    //     return this.$validator.validateAll().then((res) => {
    //             this.$root.$emit("secB", this.data);
    //             return res;
    //     });
        
    // },
  },
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
